import React, { useState, useEffect } from "react";
import "./ChatButton.css"; // File CSS riêng
import zalo from "../../assets/images/iconZalo.png";

const ChatButton = () => {
  // Số Zalo của bạn (thay bằng số thực tế, bao gồm mã quốc gia)
  const zaloPhoneNumber = "+84941604103"; // Số Zalo của bạn
  const [isMobile, setIsMobile] = useState(false);

  // Kiểm tra kích thước màn hình
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  // Chọn link phù hợp dựa trên kích thước màn hình
  const zaloLink = isMobile
    ? `https://zalo.me/${zaloPhoneNumber}`
    : `zalo://conversation?phone=${zaloPhoneNumber}`;

  return (
    <div className="chat-container">
      <a href={zaloLink} target="_blank" rel="noopener noreferrer">
        <button className="chat-button">
          <img src={zalo} alt="Zalo Chat" className="zalo-icon" />
        </button>
      </a>
    </div>
  );
};

export default ChatButton;